import { SessionStorageKey, VIN_CHARACTERS_REGEX } from 'common/constants'
import { Formik } from 'formik'
import { Button, Col, Form, Row } from 'react-bootstrap'
import * as Yup from 'yup'

const SubmitGrounding = (values) => {
  sessionStorage.setItem(SessionStorageKey.GROUND_VIN, values.vin)
  window.location.href = '/grounding'
}

const schema = Yup.object({
  vin: Yup.string().length(17, 'Must be 17 characters')
})

export const GroundingImmediately = () => {
  return (
    <Row>
      <Col>
        <Formik initialValues={{ vin: '' }} onSubmit={SubmitGrounding} validationSchema={schema}>
          {(props) => (
            <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
              <Row>
                <Form.Group className="col-lg-4 col-sm-8" controlId="vin">
                  <Row>
                    <Form.Label className="section-name" column sm="auto">
                      <h5>Enter VIN</h5>
                    </Form.Label>
                    <Col className="p-0">
                      <Form.Control
                        type="input"
                        placeholder="#17 digit VIN"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.vin}
                        isInvalid={!!props.errors.vin}
                        onKeyDown={(e) => {
                          if (!VIN_CHARACTERS_REGEX.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        maxLength={17}
                      />
                      <Form.Control.Feedback tooltip={false} type="invalid">
                        {props.errors.vin}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="col-lg-4 col-sm-4 pl-0">
                  <Button type="submit" disabled={!(props.isValid && props.dirty)} className="mx-2">
                    GROUND
                  </Button>
                  <Button className="btn-secondary" type="reset">
                    CLEAR ALL
                  </Button>
                </Form.Group>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}
